import { FunnelStage } from '@euler/lib/charts/FunnelChart/layout';
import {
  BiFunnelStage,
  biFunnelStages,
  formatBiFunnelRate,
} from '@euler/model/bi/funnel';
import { BiQueryResult } from '@euler/model/bi/result';
import { BiFunnelShow, BiFunnelViz, BiPalette } from '@euler/model/bi/viz';
import { biSeriesColor } from './biColors';
import { biVizLook } from './biVizLook';

/** A funnel as drawn: its stages, and which labels show. */
export interface BiFunnelModel {
  stages: FunnelStage[];
  showValues: boolean;
  showRates: boolean;
}

/**
 * A funnel's stages in the palette's colors, one per stage, with their
 * values and rates through the one formatter. Labels show unless the style
 * turns data labels off (`biVizLook`); `funnel.show` picks values, rates
 * or both. Null
 * when no stage has a value to draw.
 */
export function biFunnelModel(
  viz: BiFunnelViz,
  result: BiQueryResult,
  palette?: BiPalette,
): BiFunnelModel | null {
  const stages: BiFunnelStage[] = biFunnelStages(viz, result);
  if (!stages.some(stage => stage.value !== null)) return null;
  const look = biVizLook(viz);
  const labels = look.dataLabels;
  const show = look.funnel.show;
  return {
    stages: stages.map((stage, i) => ({
      name: stage.label,
      value: stage.value,
      color: biSeriesColor(viz.style, palette, stage.key, i),
      valueText: stage.display,
      stepText: i ? formatBiFunnelRate(stage.stepRate) : null,
      overallText: i ? formatBiFunnelRate(stage.overallRate) : null,
    })),
    showValues: labels && show !== BiFunnelShow.Rates,
    showRates: labels && show !== BiFunnelShow.Values,
  };
}
